module.exports = __webpack_public_path__ + "img/dashboard.f04be3b7.png";